import { useEffect, useState } from 'react';
import { RouteObject } from 'react-router-dom';
import { getMfsRoutes } from 'mf_core/routing';

import { mfNames } from '../mfNames';

export function useMfsRoutes() {
  const [routes, setRoutes] = useState<RouteObject[] | undefined>();

  useEffect(() => {
    let active = true;
    (async () => {
      const result = await getMfsRoutes(mfNames);
      if (active) {
        setRoutes(result);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return routes;
}
